module.exports = __webpack_public_path__ + "media/images/admin/undraw_Conference_speaker_re_1rna-00652fe82d34020e89be807c774828c8.png";